import { render, staticRenderFns } from "./FormThemeDrawer.vue?vue&type=template&id=3248d78d"
import script from "./FormThemeDrawer.vue?vue&type=script&lang=js"
export * from "./FormThemeDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports